export default "__VITE_ASSET__DXJ4mykY__"